import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import "./list.scss"
import InsuranceInformation from "../../components/patient-timeline/insurance-information"

const InsuranceInformationContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <InsuranceInformation />
      </div>
    </div>
  )
}

export default InsuranceInformationContainer